module.exports = __webpack_public_path__ + "static/media/beatsWhite.ffc4de6f.png";